import Avatar from "components/common/Avatar";
import { useAppContext } from "Main";
import React, { useState } from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";

const LandingRightSideNavItem = () => {
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const { logout, state } = useAppContext();
  const navigate = useNavigate();

  const { pathname: path } = useLocation();
  let { token, isLoading } = state;

  // console.log(state);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <Nav navbar className="ms-auto align-items-lg-center">
      {/* <Nav.Item as={"li"} className="me-2 d-none d-lg-block">
        <ThemeControlDropdown iconClassName="fs-10" />
      </Nav.Item> */}

      {!token ? (
        <>
          <Nav.Link as={Link} to={CONSTANT_ROUTES.AUTHENTICATION_LOGIN}>
            Sign In
          </Nav.Link>
          <Nav.Link as={Link} to={CONSTANT_ROUTES.AUTHENTICATION_REGISTER}>
            Sign Up
          </Nav.Link>
        </>
      ) : (
        <>
          <Nav.Link as={Link} to={CONSTANT_ROUTES.HOME}>
            Dashboard
          </Nav.Link>
          <Dropdown navbar={true} as="li">
            <Dropdown.Toggle
              bsPrefix="toggle"
              as={Link}
              to="#!"
              style={{ padding: 0 }}
              className="pe-0 ps-2 nav-link"
            >
              <Avatar name={state?.user?.name} />
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
              <div className="bg-white rounded-2 py-2 dark__bg-1000">
                <Dropdown.Item as={Link} to={CONSTANT_ROUTES.USERPROFILE}>
                  Profile &amp; account
                </Dropdown.Item>
                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </>
      )}
    </Nav>
  );
};

export default LandingRightSideNavItem;

//  <Nav.Item>
//             <Nav.Link
//               as={Link}
//               to="#!"
//               onClick={() => setShowRegistrationModal(!showRegistrationModal)}
//             >
//               Register
//             </Nav.Link>
//             <Modal
//               show={showRegistrationModal}
//               centered
//               onHide={() => setShowRegistrationModal(false)}
//             >
//               <Modal.Body className="p-0">
//                 <Card>
//                   <Card.Body className="fs-10 fw-normal p-4">
//                     <Registration />
//                   </Card.Body>
//                 </Card>
//               </Modal.Body>
//             </Modal>
//           </Nav.Item>
